import React from "react";
import { MimaButton, MimaInput, MimaText, Modal } from "../../components";
import { Field, FieldArray, Formik } from "formik";

const FieldInput = ({ field, ...props }) => {
  return <MimaInput {...field} {...props} />;
};

const EditPaymentMethod = ({
  closeModal,
  onSubmit,
  validationSchema,
  loading,
  selectedItem,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={4}>
        Edit Payment Method
      </MimaText>
      <Formik
        initialValues={{
          methods: selectedItem.methods.map((method) => ({
            name: method.name || "",
            requiredFields: method.requiredFields || [""],
          })),
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <>
            <FieldArray name="methods">
              {({ push, remove }) => (
                <div>
                  {values.methods.map((method, index) => (
                    <div key={index}>
                      <MimaText variant="smallBold" mb={2} mt={2}>
                        Payment Method {index + 1}
                      </MimaText>

                      <MimaInput
                        labelTitle="Method Name"
                        name={`methods.${index}.name`}
                        placeholder="Enter name"
                        value={method.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors?.methods?.[index]?.name}
                        touched={touched?.methods?.[index]?.name}
                      />

                      <MimaText variant="small" align="center">
                        Required Fields
                      </MimaText>
                      <FieldArray name={`methods.${index}.requiredFields`}>
                        {({ push, remove }) => (
                          <div>
                            {method.requiredFields.map((_, fieldIndex) => (
                              <div key={fieldIndex}>
                                <Field
                                  name={`methods.${index}.requiredFields.${fieldIndex}`}
                                  id={`methods.${index}.requiredFields.${fieldIndex}`}
                                  component={FieldInput}
                                  type="text"
                                  placeholder="Enter Field"
                                  labelTitle="Label"
                                  error={
                                    errors?.methods?.[index]?.requiredFields?.[
                                      fieldIndex
                                    ]
                                  }
                                  touched={
                                    touched?.methods?.[index]?.requiredFields?.[
                                      fieldIndex
                                    ]
                                  }
                                />
                                {fieldIndex !== 0 && (
                                  <MimaButton
                                    onClick={() => remove(fieldIndex)}
                                    buttonColor="var(--color-error)"
                                    title="Remove Field"
                                    height="4"
                                  />
                                )}
                              </div>
                            ))}
                            <MimaButton
                              title="Add Another Field"
                              variant="text"
                              type="button"
                              height={3}
                              mt={1}
                              mb={3}
                              onClick={() => push("")}
                            />
                          </div>
                        )}
                      </FieldArray>

                      {index !== 0 && (
                        <MimaButton
                          onClick={() => remove(index)}
                          buttonColor="var(--color-error)"
                          title="Remove Method"
                          height="4"
                        />
                      )}
                    </div>
                  ))}

                  <MimaButton
                    title="Add Another Payment Method"
                    variant="outlined"
                    type="button"
                    height={3}
                    mt={3}
                    onClick={() =>
                      push({
                        name: "",
                        requiredFields: [""],
                      })
                    }
                  />
                </div>
              )}
            </FieldArray>

            <MimaButton
              title="Save"
              width={38}
              buttonColor="var(--color-dark-4)"
              onClick={handleSubmit}
              loading={loading}
              mt={2}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};
export default EditPaymentMethod;
